// 新規登録のストア

import { reactive } from "vue";
import aixos from 'axios';
import router from '../router';
// import { format } from 'date-fns'

export default function katudoTouroku() {
	// 状態
	const katudo = reactive({
		// 基本（登録カード）情報
		id: "",
		password: "",
		name: "",
		kana: "",
		sex: "",
		birth: "",
		birthday: "",
		zipcode: "",
		zipcode1: "",
		zipcode2: "",
		address: "",
		tel: "",
		fax: "",
		phone: "",
		mail: "",
		job: "",
		company: "",
		keiken: "",
		age: "",
		// 同意書コード
		doui: 0,
		// 状態コード
		jyotai: 1,
	});

	// 日付を日本語表記に変更する
	const birthtoDay = async () => {
		if (katudo.birth) {
			const BD = new Date(katudo.birth);
			katudo.birthday = BD.getFullYear() + "年" + (BD.getMonth() + 1) + "月" + BD.getDate() + "日";
		}
	};
	birthtoDay();

	// 郵便番号にハイフン付与
	const toZipcode = async () => {
		if(katudo.zipcode1 && katudo.zipcode2) {
			katudo.zipcode = String(katudo.zipcode1) + "-" + String(katudo.zipcode2);
		}
	}

	// 新規登録
	const register = async () => {
		toZipcode();
		// calcYear();
		try {
			const res = await aixos.post('/api/katudosya_data/', {
	
				loginid: katudo.id,
				password: katudo.password,
				sex_code: katudo.sex,
	
				katudosya_name: katudo.name,
				katudosya_kana: katudo.kana,
				tanjyobi: katudo.birth,
				zipcode: katudo.zipcode,
				address: katudo.address,
				tel: katudo.tel,
				tel2: katudo.phone,
				fax: katudo.fax,
				mail: katudo.mail,
				syokugyo_code: katudo.job,
				kinmusaki: katudo.company,
				keiken_code: katudo.keiken,
				// 同意書コード(満18未満の人は0 ※実装できなかった？)
				// doisyo_code: (Number(katudo.age) < 18 ? 0 : 1),
				// doisyo_code: katudo.doui,
				jyotai_code: katudo.jyotai,
			})
			console.log(res)
			router.push({ path: '/katudo-touroku/registered'});
		} catch(e){
			console.log('error内容');
			console.log(e.response.status);

			let errorMessage = '';
			if (e.response && e.response.status) {
				switch (e.response.status) {
					case 500:
						errorMessage = 'サーバーエラーが発生しました。\n恐れ入りますが、時間をおいて再度お試しください。';
						break;
					default:
						errorMessage = '登録処理中にエラーが発生しました。\n青森市社会福祉協議会へお問合せください。\n（エラーコード：' + e.response.status + '）';
						break;
				}
			} else {
				errorMessage = 'ネットワークエラーが発生しました。\nインターネット接続をご確認の上、再度お試しください。';
			}
			return alert(errorMessage);
		}
	};

	const katudoReset = async () => {
		katudo.id = "";
		katudo.password = "";
		katudo.name = "";
		katudo.kana = "";
		katudo.sex = "";
		katudo.birth = "";
		katudo.birthday = "";
		katudo.zipcode = "";
		katudo.zipcode1 = "";
		katudo.zipcode2 = "";
		katudo.address = "";
		katudo.tel = "";
		katudo.fax = "";
		katudo.phone = "";
		katudo.mail = "";
		katudo.job = "";
		katudo.company = "";
		katudo.keiken = "";
		katudo.age = "";
	};

	// 年齢計算
	const calcYear = async () => {
		const today = new Date();
		const birth = new Date(katudo.birth);
		const y2 = birth.getFullYear().toString().padStart(4, '0');
		const m2 = (birth.getMonth() + 1).toString().padStart(2, '0');
		const d2 = birth.getDate().toString().padStart(2, '0');
		const y1 = today.getFullYear().toString().padStart(4, '0');
		const m1 = (today.getMonth() + 1).toString().padStart(2, '0');
		const d1 = today.getDate().toString().padStart(2, '0');
		katudo.age = Math.floor((Number(y1 + m1 + d1) - Number(y2 + m2 + d2)) / 10000);
		console.log(katudo.age + "歳")
		// if(katudo.age < 18) {
		// 	katudo.doui = 0;
		// } else {
		// 	katudo.doui = 1;
		// }
	};

	return {
		katudo,
		birthtoDay,
		register,
		toZipcode,
		katudoReset,
		calcYear,
	}
}
